import { doRequest } from "./helpers";

const SettingsService = {
  getSettings: async (asObject = false) => {
    const path = "/settings/";
    let settings = await doRequest("GET", path);
    if (asObject) {
      settings = settings.reduce((obj, cur) => {
        const { id, category, name, value } = cur;
        return {
          ...obj,
          [category]: {
            ...obj[category],
            [name]: { id, value },
          },
        };
      }, {});
    }
    return settings;
  },
  // Scoped to the piracy distance bands so map surfaces can size their
  // proximity rings without the settings read permission the full listing needs.
  getDistanceLimits: async () => {
    const { distance_limits } = await doRequest(
      "GET",
      "/settings/distance_limits",
      // The rings are decoration on a map that has to render either way, so a
      // stale permission must not raise the global forbidden modal over it.
      { suppressForbiddenModal: true }
    );
    return distance_limits;
  },
  updateSettings: newSettings => {
    const path = "/settings/";
    return doRequest("PUT", path, { data: { new_settings: newSettings } });
  },
  // The response is the only place the plain token ever appears.
  createSwoogoWebhookToken: () =>
    doRequest("POST", "/settings/swoogo_webhook_token"),
};

export default SettingsService;
